import { SetPassword } from "@/models/continente-credentials/mobile/SetPassword";
import { SetPasswordResponse } from "@/models/continente-credentials/mobile/SetPasswordResponse";
import { Response } from "@/models/continente-credentials/common/Response";

export interface ISetPasswordService {
  setPassword(
    setPassword: SetPassword,
    setPasswordUrl: string
  ): Promise<Response<SetPasswordResponse>>;
}

export class SetPasswordService implements ISetPasswordService {
  async setPassword(
    setPassword: SetPassword,
    setPasswordUrl: string
  ): Promise<Response<SetPasswordResponse>> {
    const resp = await fetch(setPasswordUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(setPassword),
    });

    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const setPasswordService = new SetPasswordService();
